/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Member_Detail_Field_ProvisioningInputs */



/**
* | output |
* | --- |
* | "Account created" |
*
* @param {Member_Detail_Field_ProvisioningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const member_detail_field_provisioning = /** @type {((inputs?: Member_Detail_Field_ProvisioningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Member_Detail_Field_ProvisioningInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konto erstellt")
	return /** @type {LocalizedString} */ ("Account created")
});